import $ from 'jquery'
import attachHeaderListener from './header'

attachHeaderListener()

/**
 * YouTube Cover
 */
$(function() {
  "use strict";

  const el = {
    vid: '.Item__video',
    vidCover: '.Item__video-cover'
  };

  const props = {
    aspectRatio: 0.5625
  };

  var func = {
    /**
     * Set the aspect ratio of an element
     * @param {string} elem
     */
    setAspectRatio: function(elem) {
      $(elem).height( $(elem).width() * props.aspectRatio );

      return this;
    },
    /**
     * Set the cover image from the youtube url.
     * This is based on the video id.
     */
    setCoverImage: function() {
      $(el.vidCover)
        .css('background-image', 'url(https://i.ytimg.com/vi/' + $(el.vid).attr('id') + '/sddefault.jpg)');

      return this;
    }
  };

  /***** Procedural Stuff Starts Here *****/

  // Set the initial state
  func.setAspectRatio(el.vidCover).setCoverImage();

  // Keep the same aspect ratio when the screen size changes.
  $(window).on('resize', function() {
    func.setAspectRatio(el.vidCover);
  });

  $(el.vidCover).on('click', function() {
    var id = $(this).children(el.vid).attr('id');

    var iframe_url = "https://www.youtube.com/embed/" + id + "?autoplay=1&autohide=1";
    var iframe = $('<iframe/>', {'frameborder': '0', 'src': iframe_url });

    $(this).children(el.vid).replaceWith(iframe);
  });
});
